import GigCards from './mp_gig_card';
import GigCard from './mp_gig_card/GigCard.js';
import ListView from './list_view_card';
import ListViewItem from './list_view_card/ListView';

if (typeof document !== 'undefined') {
    window.ListViewCard = ListView;
    window.BuyerGigCard = GigCards;
}

export { GigCards, GigCard, ListView, ListViewItem };



// WEBPACK FOOTER //
// ./src/port.js